import { DateTimePicker as MantineDateTimePicker } from '@mantine/dates';
import { useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { useFormContext } from 'src/form';
import styles from './styles.module.css';

type Props = {
  name: string;
  label: string;
  placeholder: string;
  width?: string | number;
  maxWidth?: string | number;
  minDate?: Date;
  maxDate?: Date;
};

export const InputDateTimePicker: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();
  const form = useFormContext();
  const formProps = form.getInputProps(props.name);

  return (
    <MantineDateTimePicker
      ref={ref}
      classNames={{
        input: cx(defaultStyles.input, styles.input),
        label: defaultStyles.label,
        root: cx({
          [defaultStyles.root]: true,
          [defaultStyles.rootFocused]: focused,
        }),
        weekday: styles.weekday,
        day: styles.day,
        submitButton: styles.submitButton,
        calendarHeaderLevel: styles.header,
        calendarHeaderControl: styles.control,
        monthsListControl: styles.control,
        yearsListControl: styles.control,
      }}
      timePickerProps={{
        classNames: {
          input: styles.timeInput,
        },
      }}
      popoverProps={{
        classNames: {
          dropdown: styles.popoverDropdown,
        },
      }}
      withAsterisk={false}
      w={props.width}
      maw={props.maxWidth}
      minDate={props.minDate}
      maxDate={props.maxDate}
      {...props}
      {...formProps}
    />
  );
});
